import Couchdb from './Couchdb'

const VALUE_CREATED = 'created'
const VALUE_UPDATED = 'updated'
const VALUE_DELETED = 'deleted'
const VALUE_UNCHANGED = 'unchanged'

const mergeDeeply = (target, source) => {
  source = Object.assign(target, source)
  for (let i in source) {
    if (isObject(target[i])) {
      mergeDeeply(target[i], source[i])
    }
    target[i] = source[i]
  }
}

const verifyDeeply = (field, diff, typeOfChange, ignoreFields) => {
  if (diff.hasOwnProperty('type') && typeOfChange.indexOf(diff.type) !== -1) {
    return [{
      field,
      to: diff.to,
      from: diff.from
    }]
  } else if (typeof diff === 'object') {
    return getLogDeeply(diff, typeOfChange, ignoreFields)
  }
  return false
}

const getLogDeeply = (diffs, typeOfChange, ignoreFields) => {
  let docsLogs = []
  for (let diffIndex in diffs) {
    if (ignoreFields.indexOf(diffIndex) !== -1 || (typeof diffs[diffIndex] !== 'boolean' && !diffs[diffIndex]) || diffs[diffIndex] === null) {
      continue
    }
    let log = verifyDeeply(diffIndex, diffs[diffIndex], typeOfChange, ignoreFields)
    if (log) {
      if (!diffs[diffIndex].hasOwnProperty('type')) {
        log = log.map(item => {
          if (item.hasOwnProperty('field')) {
            item.field = diffIndex + '.' + item.field
          }
          return item
        })
      }
      docsLogs = [...docsLogs, ...log]
    }
  }

  return docsLogs
}

const getDiff = (objNew, objOld) => {
  if (isValue(objNew) || isValue(objOld)) {
    return {
      type: compareValues(objNew, objOld),
      data: (typeof objNew === 'undefined') ? objOld : objNew,
      from: objOld,
      to: objNew
    }
  }

  var diff = {}

  for (var key in objNew) {
    if (isFunction(objNew[key]) || key === 'logs' || key === 'log') {
      // console.log('continue', key)
      continue
    }

    var value2 = (isFunction(objOld[key])) ? undefined : objOld[key]

    diff[key] = getDiff(objNew[key], value2)
  }

  for (var key2 in objOld) {
    if (isFunction(objOld[key2]) || (typeof (diff[key2])) !== 'undefined' || key2 === 'logs' || key2 === 'log') {
      continue
    }

    diff[key2] = getDiff(undefined, objOld[key2])
  }

  return diff
}

const compareValues = (value1, value2) => {
  if (value1 === value2) {
    return VALUE_UNCHANGED
  }

  if (isDate(value1) && isDate(value2) && value1.getTime() === value2.getTime()) {
    return VALUE_UNCHANGED
  }

  if (isDate(value1) && typeof value2 === 'string' && value1.toISOString() === value2) {
    return VALUE_UNCHANGED
  }

  if (typeof (value1) === 'undefined') {
    return VALUE_CREATED
  }

  if (typeof (value2) === 'undefined') {
    return VALUE_DELETED
  }

  return VALUE_UPDATED
}

const isFunction = obj => {
  return {}.toString.apply(obj) === '[object Function]'
}

const isArray = obj => {
  return {}.toString.apply(obj) === '[object Array]'
}

const isDate = obj => {
  return {}.toString.apply(obj) === '[object Date]'
}

const isObject = obj => {
  return {}.toString.apply(obj) === '[object Object]'
}

const isValue = obj => {
  return !isObject(obj) && !isArray(obj)
}

const flattenObject = function (ob) {
  let toReturn = {}
  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) {
      continue
    }

    if ((typeof ob[i]) === 'object') {
      let flatObject = flattenObject(ob[i])
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) {
          continue
        }

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}

const getWithPromises = (result, payload, conn = 'default') => {
  let withPromises = []
  for (const key in payload.with) {
    if (payload.with.hasOwnProperty(key)) {
      const item = payload.with[key]
      let keys = result.map((row) => {
        return row[item.localKey]
      }).filter((key) => {
        return key !== null && key !== undefined
      })
      withPromises.push(Couchdb.collection(item.collection)
      .whereIn(item.foreignKey, keys)
      .all())
    }
  }
  return withPromises
}

const bindWiths = (result, resultWiths, payload) => {
  return new Promise((resolve, reject) => {
    let i = 0
    for (const key in payload.with) {
      const item = payload.with[key]
      result.map((row) => {
        row[key] = resultWiths[i].find((obj) => {
          return obj[item.foreignKey] === row[item.localKey]
        })
      })
      i++
    }
    resolve(result)
  })
}
export {
  flattenObject,
  getWithPromises,
  bindWiths,
  isFunction,
  isArray,
  isDate,
  isObject,
  isValue,
  getDiff,
  compareValues,
  getLogDeeply,
  verifyDeeply,
  VALUE_CREATED,
  VALUE_UPDATED,
  VALUE_DELETED,
  VALUE_UNCHANGED
}



// WEBPACK FOOTER //
// ./src/services/Helper.js